// Fontawesome - Icon Set

// npm version of fa is replacing <span class='fa fa-...'> with <svg> at runtime via javascript

import '@fortawesome/fontawesome';
import '@fortawesome/fontawesome-pro-light';

var FontAwesomeConfig = { searchPseudoElements: true };